import { StripeCardElementChangeEvent } from '@stripe/stripe-js';

type CardBrand = StripeCardElementChangeEvent['brand'];

/**
 * Card brands our Stripe account cannot accept.
 *
 * Every American Express attempt on the account is rejected with
 * `card_declined` / `currency_not_supported` and, on the charge side,
 * `outcome.network_status: "not_sent_to_network"` — Stripe refuses them
 * internally and the issuer is never contacted. That holds for US-issued Amex
 * in USD too, so there is nothing a member can do to make one work. See SAV-468.
 *
 * Remove 'amex' here once Stripe enables the brand. Adding a brand needs the
 * message below updated too — it names Amex explicitly.
 *
 * Typed against Stripe's own brand union so a typo or a future rename is a
 * compile error rather than a silently disabled block.
 */
export const UNSUPPORTED_CARD_BRANDS: CardBrand[] = ['amex'];

/**
 * Names only Visa and Mastercard on purpose: those are the two brands with a
 * proven record of successful setups on this account. Discover is accepted at
 * the account level but has never been used through this flow, so recommending
 * it would be a guess.
 */
export const UNSUPPORTED_CARD_BRAND_MESSAGE =
  'American Express is not accepted. Please use a Visa or Mastercard card.';

export const isUnsupportedCardBrand = (brand?: string): boolean =>
  !!brand && (UNSUPPORTED_CARD_BRANDS as string[]).includes(brand);
